import React from 'react';
import './Banner.css';

const Banner = () => {
  return (
    <div className="banner-container">
      <div className="banner-wrapper">
        <img 
          src="/banner1.jpg" 
          alt="पुणे महानगरपालिका सार्वत्रिक निवडणूक २०२६ - राजेंद्र (बाबू) वागसकर" 
          className="banner-image"
        />
      </div>
    </div>
  );
};

export default Banner;
